module.exports = __webpack_public_path__ + "static/media/arrow-left.86060617.svg";